import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { Button } from '@calendly/ui/components/button'
import _RepurchasePageContainer from "styles-RepurchasePageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/repurchase_package/styles.js?styleId=RepurchasePageContainer";
import _Body from "styles-Body.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/repurchase_package/styles.js?styleId=Body";
import _StyledButton from "styles-StyledButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/repurchase_package/styles.js?styleId=StyledButton";


export const RepurchasePageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "RepurchasePageContainer",
  styles: _RepurchasePageContainer
})

export const Body = /*#__PURE__*/styled('div', null, {
  displayName: "Body",
  styles: _Body,
  attrs: props => ({
    ...props,
    isTabletUp: useDeviceType('isTabletUp')
  })
})

export const StyledButton = /*#__PURE__*/styled(Button, null, {
  displayName: "StyledButton",
  styles: _StyledButton
})
